<form [formGroup]="form" (ngSubmit)="onSubmit()" 
      class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">

  <div class="mt-6 mb-3">
    <h1 class="text-primary">¡Sigue avanzando!</h1>
  </div>

  @for (config of dataSelected().slice(0, 4); track $index) {
    <app-selected
      class="w-full"
      [config]="config"
      (selectValue)="handleValue($event)"
    ></app-selected>
  }

  <!-- ObligatedTaxCountry -->
  @if (form.get('isObligatedTaxOtherCountry')!.value === true || form.get('isObligatedTaxOtherCountry')!.value === 'true') {
    <div class="flex flex-col justify-center items-start w-full h-auto relative">
        <label for="obligatedTaxCountryInput" class="text-label">
            Indique cuál <b class="text-sub-label">*</b>
        </label>

        <div class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border border-blue-700 bg-white relative">
            <input
            type="text"
            id="obligatedTaxCountryInput"
            formControlName="obligatedTaxCountry"
            [value]="inputCountryValue"
            autocomplete="off"
            (input)="onSearchChange($any($event.target).value)"
            placeholder="Selecciona un país"
            class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500"
            [ngClass]="{
                'is-invalid': (form.get('obligatedTaxCountry')?.invalid || form.hasError('invalidCountry')) 
                            && (isTimeout || form.get('obligatedTaxCountry')?.touched)
            }"
            />
        </div>

        @if (filteredCountries.length > 0) {
            <div class="absolute w-full top-full left-0 z-50">
                <ul class="w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1 max-h-52 overflow-y-auto">
                @for (country of filteredCountries; track $index) {
                    <li
                    class="px-4 py-2 hover:bg-blue-100 cursor-pointer transition-colors duration-150"
                    (click)="selectCountry(country)"
                    >
                    {{ country }}
                    </li>
                }
                </ul>
            </div>
        }

        @if ((form.get('obligatedTaxCountry')?.invalid || form.hasError('invalidCountry')) 
                && (isTimeout || form.get('obligatedTaxCountry')?.touched)) {
            <div class="text-red-500 text-[10px] mt-1">
            Por favor selecciona un país válido de la lista
            </div>
        }
    </div>
  }

  
  <app-selected
  class="w-full"
  [config]="dataSelected().at(4)"
  (selectValue)="handleValue($event)"
  ></app-selected>
  

  <button class="btn-primary mb-6" [disabled]="!form.valid">
    Continuar
  </button>
</form>